import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "./SaloonOrder.css";
import OrderTable from "./components/orders/OrderTable/OrderTable/OrderTable";
import LoadingScreen from "../../../../shared/components/LoadingScreen";
import { useSaloonOrder } from "./hooks/useSaloonOrder";
import OrderControls from "./components/orders/OrderControls";
import { PageTitle } from "src/shared/PageTitle";

const SaloonOrder: React.FC = () => {
  const {
    orders,
    paginationData,
    staffList,
    staffLoading,
    searchTerm,
    setSearchTerm,
    filters,
    setFilters,
    appliedFilters,
    page,
    rowsPerPage,
    viewLoading,
    dropdownOpen,
    setDropdownOpen,
    exportLoading,
    setExportLoading,
    importLoading,
    setImportLoading,

    handleSearch,
    resetFilters,
    handleChangePage,
    handleChangeRowsPerPage,
    viewOrderPage,
    getFilterPlaceholder,
  } = useSaloonOrder();

  useEffect(() => {
        document.title = " Orders › iMetanic";
      }, []);

  if (staffLoading) return <LoadingScreen />;

  

  return (
    <div className="saloon-order-container flex flex-col h-full overflow-hidden">
      <PageTitle title="- Orders" />

      <div className="saloon-order-main">
        {(exportLoading || importLoading) && <LoadingScreen size={60} color="#1976d2" />}

        {/* Controls */}
        <OrderControls
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filters={filters}
          setFilters={setFilters}
          appliedFilters={appliedFilters}
          dropdownOpen={dropdownOpen}
          setDropdownOpen={setDropdownOpen}
          orders={orders}
          exportLoading={exportLoading}
          setExportLoading={setExportLoading}
          importLoading={importLoading}
          setImportLoading={setImportLoading}
          staffList={staffList}
          getFilterPlaceholder={getFilterPlaceholder}
          handleSearch={handleSearch}
          resetFilters={resetFilters}
          onImport={() => handleChangePage(null, page)}
        />

        <div className="mt-5 flex-1 w-fill overflow-y-auto overflow-x-hidden max-h-[calc(106vh-250px)] rounded-lg">
          <OrderTable
            data={orders}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRecords={paginationData.totalRecords}
            onPageChange={(newPage) => handleChangePage(null, newPage)}
            onRowsPerPageChange={(newSize) => {
              const fakeEvent = { target: { value: String(newSize) } } as React.ChangeEvent<HTMLInputElement>;
              handleChangeRowsPerPage(fakeEvent);
            }}
            onViewOrder={viewOrderPage}
            viewLoading={viewLoading}
          />
        </div>
      </div>

      {/* 🔹 Notifications */}
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
};

export default SaloonOrder;
